import { useCallback } from 'react'
import { saveAs } from 'file-saver'
import { utils, write, BookType } from 'xlsx'
import { captureException } from '@sentry/react'

export const useExportToXLS = (): {
  exportToCSV: (
    csvData: Array<unknown>,
    fileName: string,
    skipHeader?: boolean,
    bookType?: BookType,
  ) => void
} => {
  const exportToCSV = useCallback(
    (
      csvData: Array<unknown>,
      fileName: string,
      skipHeader = true,
      bookType: BookType = 'xlsx',
    ) => {
      try {
        const ws = utils.json_to_sheet(csvData, { skipHeader: skipHeader })
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: bookType, type: 'array' })
        const data = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        })
        saveAs(data, fileName)
      } catch (err) {
        captureException(err)
      }
    },
    [],
  )

  return {
    exportToCSV,
  }
}
